/**
 * Checks whether the given `ancestor` contains the given `element`. It
 * iterates through all ancestors of `element` until it finds `ancestor`,
 * or there is no parent anymore.
 */
export const isAncestorElementOf = (
  ancestor: Element | null,
  element: Element | null
): boolean => {
  if (ancestor && element) {
    let currentElement = element;
    while (currentElement.parentElement) {
      currentElement = currentElement.parentElement;
      if (ancestor === currentElement) {
        return true;
      }
    }
  }
  return false;
};

/**
 * Returns whether the passed HTML element is interactive input element. This can be used to verify whether
 * interactions like double clicks or keyboard shortcuts should be ignored by an outer event
 * handler. If they are applied to an interactive input element, we most likely want to execute
 * them on the element itself *only*.
 */
export const isInputElement = (element: HTMLElement): boolean =>
  ['INPUT', 'TEXTAREA', 'SELECT'].includes(element.nodeName);
